export class RelatedStoryData
{
    public id: Number;
    public coverImageUrl: String;
    public title: String;
    public url: String;
}